import { Alert, Button, Form, Input } from 'antd';
import { KeyRound } from 'lucide-react';

interface LoginCodeFormProps {
  error: string | null;
  submitting: boolean;
  onSubmit: (code: string) => void;
}

export function LoginCodeForm({ error, submitting, onSubmit }: LoginCodeFormProps) {
  return (
    <>
      <h1 className="text-2xl font-semibold tracking-tight text-fg">Two-factor authentication</h1>
      <p className="mt-1.5 mb-8 text-sm text-muted">Enter the 6-digit code from your authenticator app, or a recovery code.</p>
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      <Form<{ code: string }> layout="vertical" size="large" requiredMark={false} onFinish={(values) => onSubmit(values.code)} disabled={submitting}>
        <Form.Item name="code" label="Code" rules={[{ required: true }]}>
          <Input prefix={<KeyRound className="size-4 text-muted" />} autoComplete="one-time-code" autoFocus placeholder="123456" />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" block loading={submitting}>
            Verify
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
